<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
/*2f75f4*/
/*fd3f3f*/
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: calc(100vh - 46px);
  background: #f3f5f7;
  max-width: 800px !important;
  margin: 0 auto;
  min-width: 375px !important;
  padding: 46px 0 0 0;
}
.van-nav-bar {
  z-index: 10;
  background-color: black !important;
  color: white;
}
@media screen and (min-width: 800px) {
  .van-nav-bar__content {
    width: 800px;
    margin: 0 auto;
  }
}
.null {
  height: 46px;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.noExceed {
  white-space: nowrap;
  /*设置内容不换行*/
  text-overflow: ellipsis;
  /*设置文字超出文本框的内容显示成...*/
  overflow: hidden;
  /*设置超出隐藏*/
}
/* .van-nav-bar {
  background-color: #000 !important;
  color: #fff !important;
} */
.van-nav-bar__title {
  color: #fff !important;
}
.van-nav-bar__left,
.van-nav-bar__right {
  padding: 0 6px !important;
}
.rightBtn {
  position: relative;
  height: 2.1875rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue